module.exports = __webpack_public_path__ + "fontawesome-webfont.woff2";


//////////////////
// WEBPACK FOOTER
// /home/xpro/Documentos/ances/myjangular/src/styles/font-awesome/fonts/fontawesome-webfont.woff2?v=4.7.0
// module id = ../../../../../src/styles/font-awesome/fonts/fontawesome-webfont.woff2?v=4.7.0
// module chunks = styles